import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import { Donuz } from "@/donuz-js/Donuz";
import SocialSharing from "vue-social-sharing";
import VuejsPaginate from "vuejs-paginate";
import money from 'v-money';
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import { VueMaskDirective } from 'v-mask'
import Enter  from '@/views/enterPage/Enter.vue';

// register directive v-money and component <money>
Vue.use(money, {precision: 2})
// Or as a directive
Vue.directive('mask', VueMaskDirective);

Vue.use(VueSweetalert2);


Vue.component("paginate", VuejsPaginate);
Vue.use(SocialSharing);

// if(location.protocol=='http:'){
//   location.protocol='https:'
// }

Vue.config.productionTip = true;
// This is a global mixin, it is applied to every vue instance
Vue.mixin({
  data() {
    return {
      ESTABELECIMENTO: JSON.parse(localStorage.getItem("estabelecimento"))
    };
  }
});
new Vue({
  router,
  render: h => h(localStorage.getItem("atualizacao") == 'true' ? App : Enter )
}).$mount("#app");
